export const TELEMETRY_EVENTS = {
  pageView: 'page_view',
  ctaClick: 'cta_click',
  funnelStepView: 'funnel_step_view',
  funnelStepSubmit: 'funnel_step_submit',
  funnelStepError: 'funnel_step_error',
  paymentStarted: 'payment_started',
  paymentSuccess: 'payment_success',
  paymentFailed: 'payment_failed',
  frontendError: 'frontend_error',
  recaptchaFailed: 'recaptcha_failed',
  apiUnauthorized: 'api_unauthorized',
  apiServerError: 'api_server_error',
} as const;

export type TelemetryEventName = (typeof TELEMETRY_EVENTS)[keyof typeof TELEMETRY_EVENTS];
